import { render } from "./WalletTopup.vue?vue&type=template&id=48d5d263&scoped=true"
import script from "./WalletTopup.vue?vue&type=script&lang=js"
export * from "./WalletTopup.vue?vue&type=script&lang=js"

import "./WalletTopup.vue?vue&type=style&index=0&id=48d5d263&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d5d263"]])

export default __exports__